<template>
    <div class="vx-row">
        <edit-client
                :isSidebarActive="showSidebar"
                :data="sidebarData"
                @closeSidebar="toggleSidebar"
        />
        <div class="vx-col" id="avatar-col">
            <div class="img-container mb-4">
                <img :src="client.upload ? client.upload.full_path : '' " class="rounded w-full" />
            </div>
        </div>

        <div class="vx-col flex-1" id="account-info-col-1">
            <table>
                <tr>
                    <td class="font-semibold">Raison Sociale</td>
                    <td>{{ client.social_reason }}</td>
                </tr>
                <tr>
                    <td class="font-semibold">Segment</td>
                    <td>{{ client.segment ? client.segment.name : '' }}</td>
                </tr>
                <!--
                <tr>
                    <td class="font-semibold">Code Client</td>
                    <td>ETC-11-OK-90</td>
                </tr> -->
                <tr>
                    <td class="font-semibold">Régime</td>
                    <td>{{ client.tax }}</td>
                </tr>
                <tr>
                    <td class="font-semibold">Statut</td>
                    <td>{{ client.status == '1' ? 'Actif' : 'Suspendu'}}</td>
                </tr>
            </table>
        </div>

        <div class="vx-col flex-1" id="account-info-col-2">
            <table>
                <tr>
                    <td class="font-semibold">Email</td>
                    <td>{{ client.email }}</td>
                </tr>
                <tr>
                    <td class="font-semibold">Téléphone</td>
                    <td>{{ client.phone }}</td>
                </tr>
                <tr>
                    <td class="font-semibold">Fax</td>
                    <td>{{ client.fax }}</td>
                </tr>
                <tr>
                    <td class="font-semibold">Adresse</td>
                    <td>{{ client.address }}</td>
                </tr>
                <tr>
                    <td class="font-semibold">Sous caution</td>
                    <td>{{ client.caution == '1' ? 'Oui' : 'Non'}}</td>
                </tr>
            </table>
        </div>
      <!--
        <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather"
                       icon="icon-edit" class="mr-4"
                       @click="showSidebar = true"
                       >Modifier</vs-button>
        </div>-->
    </div>
</template>

<script>
    import EditClient from "../EditClient";
    export default {
        components: {EditClient},
        props:{
            client:{
               type: Object
            }
        },
        data() {
             return {
                 showSidebar: false,
                 sidebarData: {
                     id: 1,
                     code: 'ETC-11',
                     name: '2AK Distribution',
                     contract: 'TH009KO',
                     status: 'actif',
                     segment: 2,
                     segmentLabel: 'Assurance',
                     created_at: '12-03-2020 11:32:43',
                     logo: 'https://ebusinessafrique.com/wp-content/uploads/2020/02/logo-1.png',
                     caution: true,
                     email: 'mamama@mm.cc',
                     phone: '90 90 90 90',
                     fax: '90 90 90 90',
                     address: '123BP 45 Lomé Adidogomé - Togo',
                     regime: 'TTC',
                     contracts: [
                         {
                             id: 1,
                             code: 'psosos',
                             start: '2019-01-01',
                             end: '2020-12-31',
                             status: 'actif',
                             numbers: [
                                 {
                                     number: '90908989',
                                     service: 'OE'
                                 },
                                 {
                                     number: '9908990',
                                     service: 'OE'
                                 },
                                 {
                                     number: '90908991',
                                     service: 'OE'
                                 }
                             ]
                         }
                     ]

                 },
             }
        },
        methods: {
            toggleSidebar(val = false) {
                this.showSidebar = val;
            },
            edit(){
                // this.sidebarData = data;
                this.toggleSidebar(true);
            },
        }
    }
</script>

<style lang="scss">
    #avatar-col {
        width: 10rem;
    }

    #page-user-view {
        table {
            td {
                vertical-align: top;
                min-width: 140px;
                padding-bottom: .8rem;
                word-break: break-all;
            }

            &:not(.permissions-table) {
                td {
                    @media screen and (max-width:370px) {
                        display: block;
                    }
                }
            }
        }
    }

    // #account-info-col-1 {
    //   // flex-grow: 1;
    //   width: 30rem !important;
    //   @media screen and (min-width:1200px) {
    //     & {
    //       flex-grow: unset !important;
    //     }
    //   }
    // }


    @media screen and (min-width:1201px) and (max-width:1211px),
    only screen and (min-width:636px) and (max-width:991px) {
        #account-info-col-1 {
            width: calc(100% - 12rem) !important;
        }

        // #account-manage-buttons {
        //   width: 12rem !important;
        //   flex-direction: column;

        //   > button {
        //     margin-right: 0 !important;
        //     margin-bottom: 1rem;
        //   }
        // }

    }

</style>
